<template>
  <v-checkbox
    class="customCheckbox"
    :value="value"
    :label="label"
    color="#16293F"
    @change="$emit('input',$event)"
    @input="$emit('input',$event)"
    hide-details
  ></v-checkbox>
</template>

<script>
export default {
  name: "customCheckbox",
  props:{
    value:{
      type:Boolean,
      default:false
    },
    label:{
      type:String
    },
  }
}
</script>

<style >
.customCheckbox .v-label{
  color: black !important;
}
</style>
